import { combineReducers } from 'redux'
import accessControlReducer from './accessControlReducer'

export default combineReducers({
    accessControlModel: accessControlReducer
})